import React, { useContext, useEffect, useState } from "react";
import Slider from "react-slick";
import { formatDistanceToNow } from "date-fns";
import { arSA } from "date-fns/locale";
import "./openAuction.css";
import axios from "axios";
import { toast } from "react-toastify";
import { UserContext } from "../../context/userContext";
import { io } from "socket.io-client";
import BidModal from "../../components/bidModal/bidModal";
import { useParams } from "react-router-dom";
import { Tag, Unlock, TrendingUp } from "lucide-react";
import BidIcon from "../../assets/bidIcon.png";
import minBidIcon from "../../assets/minBidIcon.png";
import actualIcon from "../../assets/actualIcon.png";

// إعدادات السلايدر
const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  rtl: true,
};

const OpenAuction = () => {
  const { id } = useParams();
  const [bidders, setBidders] = useState([]);
  const [accordionOpen, setAccordionOpen] = useState(false);
  const [productName, setProductName] = useState("");
  const [productDescription, setProductDescription] = useState("");
  const [minBidPrice, setMinBidPrice] = useState(0);
  const [bidPrice, setBidPrice] = useState(0);
  const [actualPrice, setActualPrice] = useState(0);
  const [auction, setAuction] = useState();
  const [socket, setSocket] = useState(null);
  const [views, setViews] = useState(0);
  const [lastBidNumber, setLastBidNumber] = useState(0);
  const [lastBidName, setLastBidName] = useState("");
  const { user } = useContext(UserContext);
  const [isBroadcaster, setIsBroadcaster] = useState("");
  const [comments, setComments] = useState([]);
  const [images, setImages] = useState([]);
  const [showBidModal, setShowBidModal] = useState(false);
  const [bid, setBid] = useState();
  // تبديل حالة الأكورديون
  const toggleAccordion = () => {
    setAccordionOpen(!accordionOpen);
  };

  function handleShowBid() {
    setShowBidModal(true);
  }

  function handleBid(e) {
    e.preventDefault();

    if (+bid < +minBidPrice) {
      toast.error(`قيمة فتح باب المزاد ${+minBidPrice} ريال`);
      return;
    }

    if (+bid % +bidPrice !== 0) {
      toast.error(`يجب المزايدة بمضاعفات الرقم ${bidPrice} `);
      return;
    }

    if (+bid > +(lastBidNumber + 3 * +bidPrice) && +lastBidNumber !== 0) {
      toast.error("غير مسموح لك المزايدة بأكتر من 3 اضعاف ");
      return;
    }

    if (+bid > +actualPrice) {
      toast.error("قيمة المزاودة اعلى من حد السوم");
      return;
    }
    if (+bid <= +lastBidNumber) {
      toast.error("يجب المزايدة بمبلغ اعلى من اخر مزايدة");
      return;
    }
    socket.emit("placeBid", {
      auctionId: +id,
      userId: +user.id,
      amount: +bid,
    });
    setShowBidModal(false);
    setBid();
  }


  useEffect(() => {
    axios
      .get(process.env.REACT_APP_BASE_URL + "auctions/get-auction", {
        params: {
          auction_id: +id,
        },
      })
      .then((response) => {
        setProductName(response.data.data.current_product);
        setProductDescription(response.data.data.product_description);
        setMinBidPrice(response.data.data.minBidPrice);
        setBidPrice(response.data.data.bidPrice);
        setActualPrice(response.data.data.actualPrice);
        setAuction(response.data.data);
        setImages(response.data.data.Auction_images);
        if (response.data.data.Auction_bids.length) {
          setLastBidName(response.data.data.Auction_bids[0].user.name);
          setLastBidNumber(response.data.data.Auction_bids[0].bid);
        }
        if (+response.data.data.user_id === +user.id) {
          setIsBroadcaster("true");
        }
      })
      .catch((error) => {
        toast.error(error.message);
      });
    const socketConnection = io(process.env.REACT_APP_SOCKET_URL, {
      transports: ["websocket"],
    });

    setSocket(socketConnection);

    socketConnection.emit("joinAuction", { auctionId: +id, userId: +user.id });
    // Listen for user count updates
    socketConnection.on("userCountUpdate", (data) => {
      console.log(data);
      setViews(+data.userCount);
    });

    socketConnection.on("newComment", (data) => {
      setComments((prevComments) => [...prevComments, data.newComment]);
    });

    socketConnection.on("newBid", (data) => {
      console.log(data);
      setLastBidNumber(data.newBid.bid);
      setLastBidName(data.newBid.user.name);
      setBidders(data.auctionBids);
    });

    socketConnection.on("auction_change_product", (data) => {
      console.log(data);
      setProductName(data.product);
      setMinBidPrice(data.minBidPrice);
      setBidPrice(data.bidPrice);
      setActualPrice(data.actualPrice);
      // setAuction({
      //   ...auction,
      //   bidPrice: data.bidPrice,
      //   minBidPrice: data.minBidPrice,
      // });
    });

    socketConnection.on("auctionEnded", (data) => {
      setComments(data.auction.Auction_comments);
      setLastBidName("");
      setLastBidNumber("");
      setProductDescription("");
      setBidPrice(0);
      setMinBidPrice(0);
      setActualPrice(0);
      // setShowAwardingModal(false);
      if (+user.id !== +data.auction.user_id) {
        // setWinningUser(data.winningUser);
        // setWinningBid(data.winningBid);
        // setShowWinningModal(true);
      }
      // else if (
      //   +user.id !== +data.auction.user_id &&
      //   +data.winningUser.id !== +user.id
      // ) {
      //   console.log(isBroadcaster);
      //   console.log(data.winningUser.id);
      //   console.log(user.id);
      //   setShowLosingModal(true);
      // }
    });

    // return async () => {
    //   if (socketConnection) {

    //     socketConnection.disconnect();
    //     console.log("Socket disconnected");
    //   }
    // };
  }, [id, user.id]);

  return (
    <div className="auction-container">
      {showBidModal ? (
        <BidModal
          lastBid={minBidPrice}
          bid={bid}
          setBid={setBid}
          handleSubmit={handleBid}
          setShowModal={setShowBidModal}
        />
      ) : null}
      <div>
        
        <Slider className="image-slider" {...sliderSettings}>
          {images.map((img, index) => (
            <img
              key={index}
              src={process.env.REACT_APP_BASE_URL + "/" + img.image}
              alt={`صورة المنتج ${index + 1}`}
            />
          ))}
          
        </Slider>
      </div>

      {/* <div className="grid grid-cols-4 gap-4">
        <div className="col-span-1 flex flex-col gap-2">
          {images.map((img, index) => (
            <img
              key={index}
              src={process.env.REACT_APP_BASE_URL + "/" + img.image}
              alt="Car"
              style={{
                height: "9rem",
              }}
              className={`w-full  object-cover rounded cursor-pointer border-2 ${
                selectedImage === img ? "border-blue-500" : "border-gray-300"
              }`}
              onClick={() => setSelectedImage(img.image)}
            />
          ))}
        </div>
        <div className="col-span-3">
          <img
            src={process.env.REACT_APP_BASE_URL + "/" + selectedImage}
            alt="Selected Car"
            className="w-full h-70 object-cover rounded"
          />
        </div>
      </div> */}

      <div className="product-details">
        <h1 className="product-title">{productName}</h1>
        <p className="product-description">{productDescription}</p>
        {/* <div className="bg-gray-100 p-4 rounded-xl shadow-lg grid gap-2">
          <div className="flex items-center gap-2 bg-white p-2 rounded-lg shadow-sm">
            <Tag className="text-blue-500" size={20} />
            <p className="text-gray-700 text-lg font-bold">فرق السوم: {bidPrice} ريال</p>
          </div>
          <div className="flex items-center gap-2 bg-white p-2 rounded-lg shadow-sm">
            <Unlock className="text-green-500" size={20} />
            <p className="text-gray-700 text-lg font-bold">
              فتح الباب: {minBidPrice} ريال
            </p>
          </div>
          <div className="flex items-center gap-2 bg-white p-2 rounded-lg shadow-sm">
            <TrendingUp className="text-red-500" size={20} />
            <p className="text-gray-700 text-lg font-bold">حد السوم: {actualPrice} ريال</p>
          </div>
        </div> */}

        <div
          style={{
            justifyContent: "space-around",
          }}
          className="flex flex-wrap items-center justify-center gap-6 p-4 rounded-lg shadow-md"
        >
          {/* Fee Item */}
          <div className="flex items-center gap-2 p-3 bg-white rounded-lg">
            <img src={BidIcon} alt="Fee Icon" className="w-15 h-15" />
            <div className="flex flex-col">
              <p className="text-gray-700 text-lg font-bold">فرق الرسوم</p>
              <p className="text-gray-700 text-medium">{bidPrice} ريال سعودي</p>
            </div>
          </div>

          {/* Door Opening Fee */}
          <div className="flex items-center gap-2 p-3 bg-white rounded-lg shadow-sm">
            <img
              src={minBidIcon}
              alt="Door Opening Icon"
              className="w-15 h-15"
            />
            <div className="flex flex-col">
              <p className="text-gray-700 text-lg font-bold">فتح الباب</p>
              <p className="text-gray-700 text-medium">
                {minBidPrice} ريال سعودي
              </p>
            </div>
          </div>

          {/* Fee Limit */}
          <div className="flex items-center gap-2 p-3 bg-white rounded-lg shadow-sm">
            <img src={actualIcon} alt="Limit Icon" className="w-15 h-15" />
            <div className="flex flex-col">
              <p className="text-gray-700 text-lg font-bold">حد الرسوم</p>
              <p className="text-gray-700 text-medium">
                {actualPrice} ريال سعودي
              </p>
            </div>
          </div>
        </div>

        <div className="bid-section">
          <div className="current-bid">
            <h3>أعلى سعر حالي</h3>
            <p>{lastBidNumber} ريال</p>
            <div className="time-remaining">
              {auction
                ? formatDistanceToNow(auction?.expiryDate, {
                    addSuffix: true,
                    locale: arSA,
                  })
                : null}
            </div>
          </div>

          <button className="bid-button" onClick={handleShowBid}>
            تقديم عرض
          </button>
        </div>

        <div className="bidders-accordion">
          <h3 onClick={toggleAccordion} className="accordion-header">
            قائمة المزاودين
            <span className="arrow">{accordionOpen ? "▲" : "▼"}</span>
          </h3>
          <div className={`accordion-content ${accordionOpen ? "open" : ""}`}>
            <ul>
              {bidders.map((bidder, index) => (
                <li key={index}>
                  {bidder.user.name}: {bidder.bid} ريال
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OpenAuction;
